import { css } from '@emotion/react';
import { EmptyStates } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';

export const RetryEmptyState = <T,>({ onRetry }: { onRetry: () => T | Promise<T> }) => {
  const { t } = useTranslation('team-chat');

  return (
    <EmptyStates
      emptyStateConfig={{
        header: t('No users found'),
        disableGraphic: true,
        action: {
          label: t('Retry'),
          onClick: async () => {
            await onRetry();
          },
          css: RetryButtonStyle,
        },
        styles: emptyStateStyles,
      }}
    />
  );
};

const emptyStateStyles = css`
  padding-top: ${theme.spacing(9)};
`;

const RetryButtonStyle = css`
  background-color: transparent;
  color: ${theme.colors.primary50};
  &:hover {
    background-color: transparent;
  }
`;
